var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('chat'),_c('modal-screen',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.user.username === ''),expression:"$store.state.user.username === ''"}]})],1)}
var staticRenderFns = []

export { render, staticRenderFns }